import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../helpers/api';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import MenuWidget from '../Widget/MenuWidget';
import SocialWidget from '../Widget/SocialWidget';
import Newsletter from '../Widget/Newsletter';
import TextWidget from '../Widget/TextWidget';
const menuDataOne = [
  { title: 'About Us', href: '/about' },
//{ title: 'Departments', href: '/departments' },
  { title: 'Doctors', href: '/doctors' },
//  { title: 'Timetable', href: '/timetable' },
  { title: 'Appointment', href: '/appointments' },
  //{ title: 'Testimonials', href: '/' },
  { title: 'Contact Us', href: '/contact' },
];
const menuDataTwo = [
  { title: 'Blog', href: '/blog' },
  
  { title: 'FAQS', href: '/faqs' },
  { title: 'Privacy Policy', href: '/privacypolicy' },
  { title: 'Terms and Conditions', href: '/termsandconditions'},
];

// Falls back to these if the /settings API call fails or hasn't
// resolved yet, so the footer never renders empty.
const DEFAULT_SETTINGS = {
  title: 'Medayus Hospital Limited',
  description: '45 Wellness Avenue, Andheri West, Mumbai 400058, India',
  email: 'info@medayus.com',
  phone: '+91 9876543210',
  footer_text: 'Copyright © 2026 Medayus Hospital Limited. All rights reserved.',
};

export default function Footer() {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/settings`)
      .then((res) => {
        if (res.data && Object.keys(res.data).length) {
          setSettings((prev) => ({ ...prev, ...res.data }));
        }
      })
      .catch(() => {
        // keep DEFAULT_SETTINGS
      });
  }, []);

  return (
    <footer className="cs_footer cs_style_1 cs_heading_color">
      <div
        className="cs_footer_logo_wrap"
        style={{ backgroundImage: 'url(/images/footer_bg_1.svg)' }}
      >
        <div
          className="cs_footer_brand"
          style={{ backgroundImage: 'url(/images/footer_logo_bg.svg)' }}
        >
          <img
            src="/images/footerlogo.png"
            alt="Logo Icon"
            className="cs_footer_brand_icon"
            style={{ width: '90px', height: 'auto' }}
          />
          <h2 className="cs_footer_brand_text">MEDAYUS</h2>
        </div>
      </div>
      <div className="cs_footer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <TextWidget text={settings.title} />
                <ContactInfoWidget
                  address={settings.description}
                  email={settings.email}
                  phone={settings.phone}
                />
              </div>
            </div>
            <div className="col-lg-2">
              <div className="cs_footer_item">
                <MenuWidget data={menuDataOne} />
              </div>
            </div>
            <div className="col-lg-2">
              <div className="cs_footer_item">
                <MenuWidget data={menuDataTwo} />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <Newsletter
                  title="Be Our Subscribers"
                  subTitle="To get the latest news about health from our experts"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_footer_bottom cs_accent_bg">
        <div className="container">
          <div className="cs_footer_bottom_in">
            <SocialWidget />
            <div className="cs_copyright">
              {settings.footer_text}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
